/* Important Info component on the Add Crew Calls form
   telling users that all Crew members must be registered */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";

const ImportantCrewCalls = () => {
  return (
    <div>
        <Row className='mb-3'>
        <Col className={`text-center px-3 py-2 ${styles.SubTitle6 }`}
          md={{span: 10, offset: 1 }}>
        <h5 className={`text-center ${styles.Red }`} >CREW CALLS INFO</h5> 
        <hr className={`mt-2 mb-0`}/> 
        <p className="text-center"><span className={`${styles.Red}`}>*</span> All Crew members needed 
        to appear on the Callsheet<span className={` ${styles.Red }`}> MUST </span>be first Registered 
        and added to the Callsheet Main Crew.
        </p>
        <p className="text-center"><span className={`${styles.Red}`}>*</span> All Crew members needed 
        for a particular Shoot Day Callsheet<span className={` ${styles.Red }`}> MUST </span>be given 
        a Calltime.
        </p>
        <p className="text-center"><span className={`${styles.Red}`}>*</span> They can be given a <span className={` ${styles.Red }`}>Calltime</span> individually 
        by Department or all at once by clicking the Set Unit Call button.
        </p>    
        <p className="text-center"><span className={`${styles.Red}`}>*</span> Crew not given a Calltime
        will <span className={`${styles.Red}`}>not appear</span> on that Shoot Day's Callsheet.
        </p>    
        <hr className={`mt-2 mb-0`}/>
        </Col>
      </Row>
    </div>
  )
}

export default ImportantCrewCalls